import { useNavigate } from 'react-router-dom';
import useThread from '@/pages/Thread/hooks/useThread';
import useSession from '@/hooks/useSession';
import {
  ApproachRouteState,
  DEEP_DIVE_INDEX,
  PROMPT_APPROACHES,
} from '@/models/thread';

const DEEP_DIVE_ROUTE_STATE: ApproachRouteState = {
  approach: PROMPT_APPROACHES[DEEP_DIVE_INDEX].id,
};

/*
 * Turns Deep Dive on and leads the user to the prompt box. Pages without one
 * send the user home, whose prompt box turns Deep Dive on as it mounts.
 */
export const useTryDeepDive = (): (() => void) => {
  const {
    selectedApproach,
    setSelectedApproach,
    deepDiveAutoSelect,
    promptRef,
  } = useThread();
  const { pushUserEvent } = useSession();
  const navigate = useNavigate();

  return () => {
    pushUserEvent('click_banner_modal_try_deep_dive');
    // The banner makes this change, so a pending auto-select and its hint
    // ("on because you used it last time") would only mislead
    deepDiveAutoSelect.cancel();
    if (selectedApproach !== DEEP_DIVE_INDEX) {
      // Same prefix scheme as the switch ('toggle_') and the modal ('select_')
      pushUserEvent('banner_approach_deep-dive');
    }

    if (promptRef.current) {
      setSelectedApproach(DEEP_DIVE_INDEX);
      promptRef.current.focus();
    } else {
      navigate('/', { state: DEEP_DIVE_ROUTE_STATE });
    }
  };
};
